// export const BASE_API_URL = "http://localhost:8000/api";
// export const BASE_FILE_URL = "http://localhost:8000/storage";

export const BASE_API_URL = "https://panel.pointarkitekture.com/api";
export const BASE_FILE_URL = "https://panel.pointarkitekture.com/storage";
